import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Shared base for both the numbered page buttons and the prev/next arrows.
// 32×32 square cells, 8px radius (Figma); the active page overrides to a circle.
const baseButtonClasses =
  'tw-w-8 tw-h-8 tw-rounded-lg tw-text-sm tw-inline-flex tw-items-center tw-justify-center tw-transition';

const inactiveClasses =
  'tw-bg-white tw-border tw-border-[#e8e8e8] tw-text-body-dark hover:tw-bg-gray-50';

// Active page — brand-red FILLED CIRCLE (primary = #bf2026), white text.
const activeClasses = 'tw-bg-primary tw-text-white tw-border tw-border-primary !tw-rounded-full';

// Disabled state for the prev/next arrows.
const disabledArrowClasses =
  'disabled:tw-opacity-40 disabled:tw-cursor-not-allowed';

export function pstxPaginationButtonClasses({
  active,
}: {
  active: boolean;
}): string {
  return cn(
    baseButtonClasses,
    active ? activeClasses : inactiveClasses,
    disabledArrowClasses,
  );
}
